import {
  isBusinessLoginSelector,
  isUserVerifiedSelector,
  useUserInformationStore,
} from '@ping/stores/userInformation.store';

import { isBusinessKybLocked } from './business-kyb-lock';
import { useKybBusinessStatus } from './kyb-status.api';

export const useBusinessKybLock = () => {
  const isBusinessLogin = useUserInformationStore(isBusinessLoginSelector);
  const isVerified = useUserInformationStore(isUserVerifiedSelector);
  const status = useKybBusinessStatus({ enabled: isBusinessLogin && isVerified });

  return isBusinessKybLocked({
    isBusinessLogin,
    isVerified,
    kybStatus: isVerified ? status.data?.status : undefined,
  });
};
